// extracted by mini-css-extract-plugin
export var label = "_b0-5";
export var slideContainer = "_b0-0";
export var slider = "_b0-1";
export var sliderLg = "_b0-4";
export var sliderMd = "_b0-3";
export var sliderSm = "_b0-2";